import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { Orders } from '@hellohair/types';
import { useStyles } from '../../theme/styles.helpers';
import { PatientCardStyles } from './PatientCard.Styles';

interface PatientCardProps {
  customer: Orders.OrderCustomerDetails;
  createdAt: number;
}

const calculateAge = (birthDate: string): number => {
  const birth = new Date(birthDate);
  const now = new Date();
  let age = now.getFullYear() - birth.getFullYear();
  if (now.getMonth() < birth.getMonth() || (now.getMonth() === birth.getMonth() && now.getDate() < birth.getDate())) {
    age--;
  }
  return age;
};

const formatDate = (timestamp: number): string => new Date(timestamp).toLocaleDateString('de-DE');

const getGenderDisplay = (gender: string): string => {
  if (gender === 'Männlich' || gender === 'm') return 'm';
  if (gender === 'Weiblich' || gender === 'f') return 'w';
  return gender || 'u';
};

export const PatientCard: FC<PatientCardProps> = ({ customer, createdAt }) => {
  const styles = useStyles(PatientCardStyles, {});

  return (
    <Box sx={styles.patientCard}>
      <Typography sx={styles.cardLabel}>Patient</Typography>
      <Typography sx={styles.patientName}>{customer.customerName}</Typography>
      <Typography sx={styles.patientMeta}>
        {customer.birthDate ? `${calculateAge(customer.birthDate)} Jahre · ` : ''}
        {getGenderDisplay(customer.gender)} · Anfrage: {formatDate(createdAt)}
      </Typography>
    </Box>
  );
};
